/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TransferStatus {
    PROCESSING = 'Processing',
    COMPLETED = 'Completed',
    DECLINED = 'Declined',
    FAILED = 'Failed',
}
